export default "__VITE_ASSET__DePGlKiq__"